angular.module('impactx.supplierbasket').controller('SupplierBasketCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$context',
    'TranslationService',
    '$mdDialog',
    'BackService',
    'ConfirmationService',
    '$routeParams',
    '$redirect',
    '$mdToast',
    '$sce',
    'SupplierBasketService',
    'OutsourcedCommentSaveService',
    'AppConfiguration',
    'ToolbarService',
    '$timeout',
    SupplierBasketCtrl
]);

function SupplierBasketCtrl($scope, dataGen, ToastService, $context, TranslationService, $mdDialog, BackService,
                            ConfirmationService, $routeParams, $redirect, $mdToast, $sce, SupplierBasketService,
                            OutsourcedCommentSaveService, AppConfiguration, ToolbarService, $timeout)
{
    var self = this;
    $scope.loadingLabel = TranslationService.get('loading');
    $scope.selectedBasketItems = [];
    $scope.selectedBasketSupplier = [];
    $scope.searchText = "";
    $scope.$sce = $sce;
    $scope.supplierBasketHasChanged = false;
    $scope.deliveryDateMinValue = new Date();
    $scope.isActivated = $context.hasSupplierBasket.value;
    $scope.currentDate = new Date();
    $scope.noSave = true;
    $scope.useFreeForm = AppConfiguration.get('useFFClassicDialog');
    $scope.useFreeFormOffer = AppConfiguration.get('useFFOfferDialog');

    $scope.showItemComments = {value: false};
    $scope.locationWatcher = null;

    // object to set the forms to.
    // without this, since the forms are inside a ng-if, the form-objects would be set to the ng-if's isolate scope.
    $scope.forms = {};

    self.toggleItemComments = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };

    var mainView = angular.element("#main-content");
    mainView.bind("scroll", function () {
        self.placeRefreshButton();
    });

    self.isActivated = function () {
        return $context.hasSupplierBasket.value && $context.hasSupplierBasket.id === $scope.data.id;
    };

    self.getSupplierBasket = function (bkhId, userId, comId) {
        $scope.isActivating = true;
        if ($routeParams.activate) {
            dataGen.postAsForm({}, {id: $routeParams.id}, "/supplierbasket/activate").then(function (data) {
                self.getSupplierBasketInternal(bkhId, userId, comId).then(function () {
                    if (data.data) {
                        $context.refreshBasket({}, dataGen, $context);
                        $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                            if (self.isActivated()) {
                                $scope.isActivated = true;
                                // only register this watcher if the sbt has actually been activated
                                $scope.locationWatcher = $scope.$on('$locationChangeStart', function (event) {
                                    if (!$scope.noSave) {
                                        self.save();
                                    }
                                });

                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(data.trns.sbtActivated.replace("^0", data.data.templateName))
                                        .position("bottom right")
                                        .hideDelay(5000)
                                );
                            }
                        });
                    }
                });
            });
        }
        else {
            self.getSupplierBasketInternal(bkhId, userId, comId);
        }
    };

    self.getSupplierBasketInternal = function (bkhId, userId, comId) {
        var dataObj = {
            bkhId: bkhId,
            userId: userId ? userId : 0,
            comId: comId ? comId : 0
        };
        return dataGen.getData($scope, dataObj, "/supplierbasket/view").then(function () {
            $scope.isActivating = false;
            $scope.noSave = !$scope.data.canAddProducts || $scope.data.isReadOnly;
            // need another digest cycle here since the forms are only set to the scope after $scope.isActivating is set to false
            // if we don't timeout the button definition, the validation button doesn't have the form-object and won't
            // validate at all
            $timeout(defineButtons, 0);
        });
    };

    self.getSupplierBasket($routeParams.id, $routeParams.userId, $routeParams.comId);

    self.saveWithoutRedirect = function () {
        self.save();
        $scope.selectedBasketItems = [];
        $scope.selectedBasketSupplier = [];
    };

    self.back = function () {
        if ($scope.locationWatcher) {
            $scope.locationWatcher();
        }
        if (self.isActivated()) {
            SupplierBasketService.deactivateActiveSupplierBasket().then(function (data) {
                $context.refreshBasket({}, dataGen, $context);
                $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                    if (impactX.isDefined(data, "trns.sbtDeactivated")) {
                        ToastService.openStandardToast(data.trns.sbtDeactivated.replace("^0", data.data.basketName));
                    }
                    $scope.noSave = true;
                    $redirect.redirectTo(null, '/supplierbaskettemplatelist/')
                });
            });
        }
        else {
            $redirect.redirectTo(null, '/supplierbaskettemplatelist');
        }
    };

    self.saveSupplierBasket = function () {
        if ($routeParams.id === "0") {
            return self.save(function (data) {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $routeParams.id = data.id;
                $routeParams.userId = 0;
                $routeParams.comId = 0;
                $routeParams.activate = $context.showSupplierBasket.value;
                self.getSupplierBasket(data.id, data.userId, data.orderComId);
            });
        }
        else {
            return self.save(function () {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $scope.noSave = true;
                $redirect.redirectTo(null, "/supplierbaskettemplatelist");
                SupplierBasketService.deactivateActiveSupplierBasket().then(function() {
                    $context.refreshBasket({}, dataGen, $context);
                    $context.refreshSearchInfo({}, dataGen, $context);
                });
            })
        }
    };

    self.postSave = function (callback) {
        $scope.supplierBasketHasChanged = false;
        if (angular.isFunction(callback)) {
            callback($scope.data);
        }
    };

    self.save = function (callback) {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data);
        if ($scope.data.hasOwnProperty('commentData')) {
            delete $scope.data.commentData; // remove if set, only happens on "saveWithoutRedirect()"
        }

        return dataGen.postAsForm($scope, {data: $scope.data}, "/supplierbasket/save").then(function (data) {
            if (data && data.data && data.data.commentData) {
                OutsourcedCommentSaveService.saveComments(data.data.commentData, extractedComments).then(function () {
                    self.postSave(callback);
                });
            }
            else {
                self.postSave(callback);
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments($scope.data, extractedComments);
        });
    };

    self.canEditReferences = function () {
        return !$scope.data.isReadOnly && $scope.selectedBasketItems.length === 1 && $scope.data.isSupplier && $scope.selectedBasketItems[0].isSelectReferenceMain;
    };

    self.editReferences = function (event) {
        $mdDialog.show({
            controller: "SelectReferenceDialogCtrl",
            controllerAs: "selectReferenceDialogCtrl",
            templateUrl: 'shared/basketlink/templates/selectreference.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                proId: 0,
                bkiId: $scope.selectedBasketItems[0].id,
                canDecideLater: false
            }
        }).then(function () {
            $scope.selectedBasketItems.length = 0;
            self.getSupplierBasketInternal($routeParams.id, $routeParams.userId, $routeParams.comId);
            $context.refreshBasket({}, dataGen, $context);
            ToastService.openStandardToast($scope.trns.referencesUpdated);
        });
    };

    self.deleteSupplierBasketItems = function () {
        var i, dataObj;

        $scope.lastDeleted = [];

        for (i = 0; i < $scope.selectedBasketItems.length; i++) {
            $scope.selectedBasketItems[i].selected = false;
            $scope.lastDeleted[i] = $scope.selectedBasketItems[i];
        }

        $scope.selectedBasketItems = [];

        dataObj = {
            bkhId: $scope.data.id,
            deleted: $scope.lastDeleted[0]
        };

        return dataGen.postAsForm($scope, dataObj, "/supplierbasket/items/delete").then(function (data) {
            $scope.data = data.data;
            ToastService.openStandardToast("Position " + $scope.lastDeleted[0].name.value + " wurde aus der Vorlage entfernt");
            $context.refreshBasket({}, dataGen, $context);
        });
    };

    self.showAddFreeformDialog = function (ev) {
        self.save(function () {
            showItemDialog(ev, 0);
        })
    };

    self.showFreeformDialog = function (ev) {
        self.save(function () {
            var basketItemId = 0;
            if ($scope.selectedBasketItems[0]) {
                basketItemId = $scope.selectedBasketItems[0].id;
            }
            showItemDialog(ev, basketItemId);
        })
    };

    var showItemDialog = function (ev, basketItemId) {
        $mdDialog.show({
            controller: 'EditFreeFormCtrl',
            templateUrl: 'modules/supplierbasket/templates/supplierbasketfreeformdialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                itemId: basketItemId,
                headerId: $scope.data.id,
                entryPointGet: '/basket/item/freeform/view',
                entryPointSave: '/basket/item/freeform/save',
                changeAATEntryPoint: '/basket/item/updateavailablecontrols',
                lotId: 0,
                productId: 0,
                readOnly: !($scope.data.canAddFreeform && self.isActivated()),
                materialGroupMappingEntryPoint: "/basket/input/eclassmapping",
                hideOrderData: false,
                headerTable: "BKH"
            }
        }).then(function () {
            $context.refreshBasket({}, dataGen, $context);
            $scope.selectedBasketItems = [];
            self.getSupplierBasket($scope.data.id);
        }, function () {
            $scope.selectedBasketItems = [];
        });
    };

    self.showBasketItemOfferDialog = function (ev, basketItemGroupId) {
        self.save(function () {
            $mdDialog.show({
                controller: "EditFreeFormOfferCtrl",
                controllerAs: "editFreeFormOfferCtrl",
                templateUrl: 'modules/basket/templates/freeformofferdialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    basketItemGroupId: basketItemGroupId ? basketItemGroupId : 0,
                    headerId: $scope.data.id,
                    hideOrderData: false,
                    lotId: 0, // no lot to reduce to
                    supplierId: 0, //no supplier to reduce to
                    product: null,
                    allowBANF: false,
                    onlyBANF: false
                }
            }).then(function () {
                $context.refreshBasket({}, dataGen, $context);
                $scope.selectedBasketItems = [];
                self.getSupplierBasket($scope.data.id);
            }, function () {
                $scope.selectedBasketItems = [];
            });
        })
    };

    self.deleteBasketItemGroup = function (event, basketItemGroupId) {
        $scope.selectedBasketItems = [];
        for (var i = 0; i < $scope.data.supplierHeaders.length; i++) {
            var basketSupplier = $scope.data.supplierHeaders[i];
            for (var j = 0; j < basketSupplier.basketItemList.length; j++) {
                if (basketSupplier.basketItemList[j].basketItemGroupId === basketItemGroupId) {
                    $scope.selectedBasketItems.push(basketSupplier.basketItemList[j]);
                }
            }
        }
        self.deleteSupplierBasketItems();
    };

    self.setReadyToOrder = function () {
        dataGen.postAsForm($scope, {data: $scope.data}, "/supplierbaskettemplate/orderSBT").then(function () {
            ToastService.openStandardToast($scope.trns.orderSuccess);
            SupplierBasketService.deactivateActiveSupplierBasket().then(function (data) {
                $scope.isActivated = false;
                $context.refreshBasket({}, dataGen, $context);
                $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                    if (impactX.isDefined(data, "trns.sbtDeactivated")) {
                        ToastService.openStandardToast(data.trns.sbtDeactivated.replace("^0", data.data.basketName));
                    }
                    $scope.noSave = true;
                    $redirect.redirectTo(null, '/supplierbaskettemplatelist/')
                });
            });
        });
    };

    self.reworkSBT = function () {
        return dataGen.postAsForm($scope, {data: $scope.data}, "/supplierbaskettemplate/reworkSBT").then(function (data) {
            $scope.noSave = true;
            $redirect.redirectTo(null, 'supplierbasket/' + $routeParams.id + '/0/0' +
                (data.data.canActivate ? '/1' : ''));
        }, function () {
            $scope.data.canRework = false;
        });
    };

    self.delete = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm($scope, {id: $scope.data.id}, "/supplierbaskettemplate/delete").then(function () {
                ToastService.openStandardToast($scope.trns.deleteSuccess);
                $context.refreshBasket({}, dataGen, $context);
                $context.refreshSearchInfo({}, dataGen, $context);
                $scope.noSave = true;
                BackService.back();
            });
        }, event, $scope.trns.confirmDelete, TranslationService.get("delete"), TranslationService.get("abort"));
    };

    self.addToCurrentBasket = function () {
        return dataGen.post($scope, {selected: [{id: $scope.data.id}]}, "/basket/addtocurrentbasket").then(function () {
            $context.refreshBasket({}, dataGen, $context);
            $scope.noSave = true;
            $redirect.redirectTo(null, "/basket");
        }, function () {
            $context.refreshBasket({}, dataGen, $context);
        });
    };

    self.placeRefreshButton = function () {
        if ($scope.supplierBasketHasChanged) {
            var summaryElement = angular.element('#basket-summary');
            var stickyButtonElement = angular.element('#stickyRefreshButton');

            var middle = (summaryElement.offset().top + summaryElement.height());
            if (middle < (mainView.offset().top + mainView.height())) {
                stickyButtonElement.css({
                    "position": "absolute",
                    "bottom": "",
                    "right": "24px",
                    "top": "30%"
                });
            }
            else {
                stickyButtonElement.css({
                    "position": "fixed",
                    "bottom": "32px",
                    "right": "48px",
                    "top": ""
                });
            }
        }
    };

    self.markSupplierBasketAsChanged = function (isValid) {
        if (isValid !== undefined) {
            $scope.supplierBasketHasChanged = isValid;
        }
        else {
            $scope.supplierBasketHasChanged = true;
        }
    };

    self.openInformationTextDialog = function (event) {
        if (!$scope.data.informationText) {
            var tmpScope = {};
            dataGen.getData(tmpScope, {
                userId: $scope.data.buyer.id,
                comId: $scope.data.orderComId
            }, "/supplierbaskettemplate/clientinformationtext").then(function () {
                if (tmpScope.data) {
                    $scope.data.informationText = tmpScope.data.informationText;
                    showInformationDialog(event)
                }
            });
        }
        else {
            showInformationDialog(event)
        }
    };

    self.getDetailsLabel = function () {
        return $scope.data.canAddFreeform && self.isActivated() ? $scope.trns.edit : $scope.trns.details;
    };
    self.canSave = function () {
        return !$scope.data.isReadOnly;
    };
    self.canDelete = function () {
        return !$scope.data.isReadOnly && $scope.data.id > 0;
    };
    self.canRework = function () {
        return $scope.data.canRework;
    };
    self.canAddToBasket = function () {
        return $scope.data.canAddToBasket;
    };
    self.canViewDetails = function () {
        return !$scope.data.isReadOnly && $scope.selectedBasketItems.length === 1 && $scope.selectedBasketItems[0].isFreeform;
    };
    self.canAddFreeform = function () {
        return $scope.useFreeForm && self.isActivated() && $scope.data.canAddFreeform && !$scope.data.isReadOnly;
    };
    self.canAddFreeformOffer = function () {
        return $scope.useFreeFormOffer && self.isActivated() && $scope.data.canAddFreeform && !$scope.data.isReadOnly;
    };
    self.canDeleteItems = function () {
        return !$scope.data.isReadOnly && $scope.selectedBasketItems.length === 1 && $scope.data.isSupplier;
    };
    self.canToggleComments = function () {
        return !$scope.data.isReadOnly && $scope.selectedBasketItems.length === 1;
    };

    function showInformationDialog(event) {
        $mdDialog.show({
                templateUrl: 'modules/supplierbasket/templates/supplierbasketinformationtextdialog.html',
                controller: 'SupplierBasketInformationTextCtrl',
                controllerAs: 'supplierBasketInformationTextCtrl',
                parent: angular.element(document.body),
                targetEvent: event,
                locals: {
                    informationText: $scope.data.informationText
                }
            }
        );
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('back'),
                action: self.back,
                type: 'dialogaction',
            },
            {
                label: $scope.trns.save,
                action: self.saveSupplierBasket,
                type: 'validation',
                condition: self.canSave,
                params: {
                    form: $scope.forms.releaseData
                }
            },
            {
                label: $scope.trns.deleteTemplate,
                action: self.delete,
                type: 'dialogaction',
                condition: self.canDelete
            },
            {
                label: $scope.trns.rework,
                action: self.reworkSBT,
                type: 'dialogaction',
                condition: self.canRework
            },
            {
                label: $scope.trns.addToBasket,
                action: self.addToCurrentBasket,
                type: 'dialogaction',
                condition: self.canAddToBasket
            },
            {
                label: $scope.trns.addFreeForm,
                action: self.showAddFreeformDialog,
                type: 'dialogaction',
                condition: self.canAddFreeform
            },
            {
                label: $scope.trns.addFreeFormOffer,
                action: self.showBasketItemOfferDialog,
                type: 'dialogaction',
                condition: self.canAddFreeformOffer
            },
            {
                labelFunction: self.getDetailsLabel,
                action: self.showFreeformDialog,
                type: 'dialogaction',
                condition: self.canViewDetails
            },
            {
                label: $scope.trns.comments,
                action: self.toggleItemComments,
                type: 'dialogaction',
                condition: self.canToggleComments
            },
            {
                label: $scope.trns.remove,
                action: self.deleteSupplierBasketItems,
                type: 'dialogaction',
                condition: self.canDeleteItems
            },
            {
                label: $scope.trns.references,
                action: self.editReferences,
                type: 'dialogaction',
                condition: self.canEditReferences
            }
        ];

        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }
}